var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "35px",
    height: "27px",
    viewBox: "0 0 35 27",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-108.000000, -74.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(108.000000, 74.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 35,
    height: 27
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(14.000000, 10.000000)",
    stroke: "#575E71",
    strokeLinecap: "square",
    strokeWidth: 1.125
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0.376226578,
    y1: 6.58840959,
    x2: 7.62377342,
    y2: 1.41159041,
    transform: "translate(4.000000, 4.000000) rotate(80.537678) translate(-4.000000, -4.000000) "
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.376226578,
    y1: 6.58840959,
    x2: 7.62377342,
    y2: 1.41159041,
    transform: "translate(4.000000, 4.000000) rotate(-9.462322) translate(-4.000000, -4.000000) "
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.26c44da2.svg";
export { ForwardRef as ReactComponent };